import { TableCell, TableRow, styled } from "@mui/material";
import { colors, fonts } from "@constants/cssVariables";
import * as StyledParagraph from "../RichTextParagraph/RichTextParagraph.styled";

export const Row = styled(TableRow)({
  "&:nth-of-type(odd)": {
    backgroundColor: colors.neutral10,
  },
});

export const TableHeaderCell = styled(TableCell)({
  [`${StyledParagraph.Paragraph}`]: {
    font: fonts.bodyMediumStrong,
  },
});
